module.exports = __webpack_public_path__ + "ad7f4827c2565392c922c9e4c12ba3b2.pdf";